import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
import { SupportTicketListComponent } from './ticket-list.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MomentModule,
  ],
  declarations: [SupportTicketListComponent],
  exports: [SupportTicketListComponent],
})
export class SupportTicketListModule {
}
